import ContentGuide from '@/global/guides/ContentGuide'
import { type CompensacaoManual, compensacaoManual } from '@/service/api'
import { useStore } from '@/store'
import { columns } from '@/templates/ManutencaoDoPonto/CompensacaoManual/columns'
import { Outlet, useOutletContext } from 'react-router-dom'

export default function CompensacaoManualPage() {
    const empresaId = useStore(state => state.companyId)
    const competencia = useStore(state => state.selectedCompetence)

    const {
        data = [],
        isLoading,
        refetch,
    } = compensacaoManual.useFetch({
        queryParams: {
            empresaId,
            competencia,
        },
    })

    return (
        <ContentGuide>
            <ContentGuide.Card>
                <ContentGuide.Header
                    label={['Manutenção do Ponto', 'Compensação Manual']}
                />
                <ContentGuide.DataGrid
                    loading={isLoading}
                    columns={columns}
                    rows={data}
                    ToolbarProps={{
                        showQuickFilter: true,
                        showVisibilityButton: true,
                        exportButtonProps: {
                            fileName: 'compensacao-manual',
                        },
                    }}
                    onAdd
                />
            </ContentGuide.Card>
            <Outlet
                context={{
                    data: new Map(data.map(item => [item.id, item])),
                    refetch,
                }}
            />
        </ContentGuide>
    )
}

export function useCompensacaoManual() {
    return useOutletContext<{
        data: Map<number, CompensacaoManual>
        refetch: () => void
    }>()
}
